var App = App || {};

App.Modals = (function () {
    'use strict';

    const fetchModalUrls = () => {

        return fetch('/Api/Modals/GetModalUrls', {
            method: 'GET'
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(result => {
                return [...result];
            })
            .catch(error => {
                console.error('Error fetching modal URLs:', error);
                return [];
            });
    };

    // Opens the modal whose URL matches the hash (e.g. #/modals/foo); returns true if one matched
    const openModalFromHash = (modalUrls, href) => {

        if (!href || href === "#")
            return false;

        const trimSlashes = value => value.replace(/^\/+|\/+$/g, "").toLowerCase();
        const normalizedHash = trimSlashes(href.startsWith("#") ? href.slice(1) : href);
        if (!normalizedHash)
            return false;

        const matchedUrl = modalUrls.find(url => url && trimSlashes(url) === normalizedHash);
        if (!matchedUrl)
            return false;

        openModal(matchedUrl, null);
        return true;
    };

    const openModalFromAnchor = (modalUrls, anchor) => {

        const href = anchor.getAttribute("href");
        if (!href || !modalUrls.some(url => url.toLowerCase() === href.toLowerCase()))
            return false;

        openModal(href, anchor);
        return true;
    };

    // Fetches the modal page at url, appends its modal or offcanvas to <body> and shows it, returning focus to anchor on close
    const openModal = (url, anchor) => {

        fetch(url, { method: "GET" })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.text();
            })
            .then(result => {

                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = result;

                const modalElement = tempDiv.querySelector(".modal, .offcanvas");
                if (!modalElement) return;

                const modalData = {
                    id: modalElement.id,
                    content: modalElement.outerHTML
                };

                document.body.insertAdjacentHTML("beforeend", modalData.content);
                App.Helpers.markNewWindowLinks(document.getElementById(modalData.id));
                showModalInstance(modalData.id, anchor);
            })
            .catch(error => {
                console.error("Error loading modal:", error);
            });
    };

    const showModalInstance = (modalId, anchor) => {

        const modalElement = document.getElementById(modalId);
        if (!modalElement) return;

        App.Helpers.responsiveTables(modalElement);

        let hideEvent = null;
        let hiddenEvent = null;
        let modalInstance = null;

        if (modalElement.classList.contains("modal")) {
            hideEvent = "hide.bs.modal";
            hiddenEvent = "hidden.bs.modal";
            modalInstance = new bootstrap.Modal(modalElement);
        }
        else if (modalElement.classList.contains("offcanvas")) {
            hideEvent = "hide.bs.offcanvas";
            hiddenEvent = "hidden.bs.offcanvas";
            modalInstance = new bootstrap.Offcanvas(modalElement);
        }

        // move focus out before Bootstrap sets aria-hidden on the modal (Chrome warns about aria-hidden on a focused element)
        modalElement.addEventListener(hideEvent, () => {
            if (modalElement.contains(document.activeElement)) document.activeElement.blur();
        });

        modalElement.addEventListener(hiddenEvent, () => {

            // hidden by the speed bump: keep it for the speed bump to reopen, which also restores focus
            if (App.SpeedBump.getTriggeredByModal() === modalInstance) return;

            modalInstance.dispose();
            modalElement.remove();

            // WCAG 2.4.3: return focus to the link that opened the modal (blurring it would drop focus to <body>)
            if (anchor && anchor.isConnected) {
                anchor.focus();
            }
        });

        modalInstance.show();
    };

    return {
        fetchModalUrls,
        openModalFromHash,
        openModalFromAnchor
    };

})();